
class ValidationHelper {

    static exists(value) {
        return (value !== null && typeof value !== 'undefined')
    }
}

export default ValidationHelper